import { useDesignTokens } from "@boi/react-design-tokens";

import { Typography } from "../../Typography";
import {
  useSliderValueAsPercent,
  useNotchTooltip,
  useIsTooltipNotches,
} from "../../SliderBase/hooks";
import { type SliderProps } from "..";
import * as S from "./SliderTooltip.styled";

type SliderTooltipProps = Pick<
  SliderProps,
  "notches" | "value" | "minValue" | "maxValue" | "testID"
>;

const NBSP = "\u00A0";

function SliderTooltip(props: SliderTooltipProps) {
  const { notches, testID = "slider" } = props;
  if (!useIsTooltipNotches(notches)) return null;

  const { tokens } = useDesignTokens();
  const { tooltip } = tokens;
  const sliderPercent = useSliderValueAsPercent(props);
  const tooltipText = useNotchTooltip(props);

  const tooltipDisplay = tooltipText || NBSP;

  return (
    <S.Wrapper data-testid={`${testID}-tooltip`}>
      <S.Padding $location="left" $sliderPercent={sliderPercent} />
      <S.Content $isHidden={!tooltipText}>
        <Typography
          color={tooltip.color}
          variant={tooltip.typography.variant}
          fontFamily={tooltip.typography.fontFamily}
          testID={`${testID}-tooltip-text`}
        >
          {tooltipDisplay}
        </Typography>
      </S.Content>
      <S.Padding $location="right" $sliderPercent={sliderPercent} />
    </S.Wrapper>
  );
}

export default SliderTooltip;
